import React, { Component } from 'react'

import Overlay from './Overlay'
import IconMenu from './IconMenu'

class MobileNav extends Component {
	state = {
		showOverlay: false
	}

	constructor(...args) {
		super(...args)

		this.toggleOverlay = this.toggleOverlay.bind(this)
	}

	toggleOverlay(state) {
		this.setState({
			showOverlay: state
		})
	}

	render() {
		return (
			<div style={{ display: 'flex' }}>
				<IconMenu
					onClick={this.toggleOverlay.bind(null, true)}
					style={{
						width: 40,
						height: 40,
						marginRight: 24
					}}
				/>
				{this.state.showOverlay && (
					<Overlay toggleOverlay={this.toggleOverlay} />
				)}
			</div>
		)
	}
}

export default MobileNav



// WEBPACK FOOTER //
// ./src/components/Layout/nav/MobileNav/index.js